import httpClient from "@utils/httpClient";

// Create new payroll
export const createNewPayRoll = async (payload) => {
  try {
    const response = await httpClient.post('/hr/payroll', payload);

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('createNewPayRoll error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Get all payrolls with optional filters
export const getAllPayrolls = async (params = {}) => {
  try {
    const response = await httpClient.get('/hr/payroll', { params });

    return {
      success: response.success,
      data: response.data,
      pagination: response.pagination,
      error: response.error
    };
  } catch (error) {
    console.error('getAllPayrolls error:', error);
    return {
      success: false,
      data: null,
      pagination: null,
      error: { message: error.message }
    };
  }
};

// Get payroll by ID
export const getPayrollById = async (id) => {
  try {
    const response = await httpClient.get(`/hr/payroll/${id}`);

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('getPayrollById error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Update payroll
export const updatePayroll = async (id, payload) => {
  try {
    const response = await httpClient.put(`/hr/payroll/${id}`, payload);

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('updatePayroll error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Delete payroll
export const deletePayroll = async (id) => {
  try {
    const response = await httpClient.delete(`/hr/payroll/${id}`);

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('deletePayroll error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Create employee payroll
export const createEmployeePayroll = async (payload) => {
  try {
    const response = await httpClient.post('/hr/payroll/employee-payroll', payload);

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('createEmployeePayroll error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Get employee payrolls by payroll ID
export const getEmployeePayrollsByPayrollId = async (payrollId) => {
  try {
    const response = await httpClient.get(`/hr/payroll/${payrollId}/employees`);

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('getEmployeePayrollsByPayrollId error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Get employee payroll by ID
export const getEmployeePayrollById = async (id) => {
  try {
    const response = await httpClient.get(`/hr/payroll/employee-payroll/${id}`);

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('getEmployeePayrollById error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Get employee payroll by payroll ID and employee payroll ID (for edit/view pages)
export const getEmployeePayrollByIds = async (payrollId, employeePayrollId) => {
  try {
    const response = await httpClient.get(`/hr/payroll/${payrollId}/employee/${employeePayrollId}/view`);

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('getEmployeePayrollByIds error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Update employee payroll
export const updateEmployeePayroll = async (id, payload) => {
  try {
    const response = await httpClient.put(`/hr/payroll/employee-payroll/${id}`, payload);

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('updateEmployeePayroll error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Delete employee payroll
export const deleteEmployeePayroll = async (id) => {
  try {
    const response = await httpClient.delete(`/hr/payroll/employee-payroll/${id}`);

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('deleteEmployeePayroll error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Send salary slip email to employee
export const sendSalarySlipEmail = async (employeePayrollId) => {
  try {
    const response = await httpClient.post(`/hr/payroll/employee-payroll/${employeePayrollId}/send-email`);

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('sendSalarySlipEmail error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Download salary slip PDF
export const downloadSalarySlipPDF = async (employeePayrollId) => {
  try {
    // Get the base URL from environment or use default
    const baseURL = process.env.REACT_APP_API_BASE_URL || 'https://nucleus.api.milekraft.com/api';
    const token = localStorage.getItem('authToken');

    // Create the download URL
    const url = `${baseURL}/hr/payroll/employee-payroll/${employeePayrollId}/download-pdf`;

    // Fetch the PDF blob
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error?.message || 'Failed to download PDF');
    }

    // Get the filename from the Content-Disposition header
    const contentDisposition = response.headers.get('Content-Disposition');
    let filename = 'Salary_Slip.pdf';
    if (contentDisposition) {
      const matches = /filename="([^"]*)"/.exec(contentDisposition);
      if (matches && matches[1]) {
        filename = matches[1];
      }
    }

    // Get the blob
    const blob = await response.blob();

    // Create a download link and trigger download
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);

    return {
      success: true,
      data: { message: 'PDF downloaded successfully' },
      error: null
    };
  } catch (error) {
    console.error('downloadSalarySlipPDF error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

// Get public salary slip via QR code
export const getPublicSalarySlip = async (employeePayrollId, token) => {
  try {
    const response = await httpClient.get(`/hr/payroll/public/salary-slip/${employeePayrollId}/${token}`);

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('getPublicSalarySlip error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};
